const INTERNAL_ADMIN_EMAIL_DOMAIN = "@octogen.io";

export function isInternalUser(email: string | null | undefined): boolean {
  return !!email && email.toLowerCase().endsWith(INTERNAL_ADMIN_EMAIL_DOMAIN);
}
